import { Alert } from '@backstage/ui';
import { relTime } from '@internal/backstage-plugin-catalog-devops-common';
import { useAccountContext } from '../Providers';

export function AccountScanInfo() {
  const {
    scanTaskStartTime,
    isLoading,
    isProcessing,
    progress,
    stage,
    stages,
    percent,
  } = useAccountContext();

  return isLoading || !isProcessing ? (
    <></>
  ) : (
    <Alert
      key="scan-info"
      status="info"
      icon
      title={`Account scan is in progress. General progress: ${progress ?? 0}%. Started ${relTime(scanTaskStartTime)}.`}
      description={
        stage
          ? `Scan stage: ${stage} of ${stages}. Current stage progress: ${percent}%`
          : undefined
      }
    />
  );
}
